import { render, staticRenderFns } from "./linkedcommodity.vue?vue&type=template&id=7d67c487"
import script from "./linkedcommodity.vue?vue&type=script&lang=ts"
export * from "./linkedcommodity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports